/* eslint-disable-next-line import/no-restricted-paths */
import { analyticsUtils } from './analytics-utils';

type TGAEvents = {
  pagePath?: string;
  userId?: string;
  cityId?: string;
  elementName?: string;
  elementText?: string;
  elementBlock?: string;
  elementType?: string;
  elementContext?: string[];

  promotions?: Array<{
    name: string; // расположение баннера
    creative: string; // название баннера
    position: number; // номер позиции баннера
  }>;
};

export type TGAImpressions = {
  elementName?: string;
  productName: string;
  productId: string;
  productPrice: string;
  productQuantity?: number;
  productPosition: string;
  elementBlock?: string;
};

export const GAClickButton = ({
  elementName,
  elementText,
  elementBlock,
  elementContext,
}: Pick<TGAEvents, 'elementName' | 'elementText' | 'elementBlock' | 'elementContext'>) =>
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock, // блок, в котором расположен элемент
    elementName, // название блока (т.е. или “Услуги по ремонту”)
    elementText, // текст кнопки
    elementContext,
  });

export const GAPromoView = ({
  promotions,
  elementBlock,
  elementType,
}: Pick<TGAEvents, 'promotions' | 'elementBlock' | 'elementType'>) =>
  analyticsUtils.sendEvent('GA:promoView', {
    elementType: elementType || 'banner',
    elementBlock, // блок, в котором расположен элемент
    promotions, // массив объектов с данными
  });

export const GAPromoClick = ({ promotions, elementBlock }: Pick<TGAEvents, 'promotions' | 'elementBlock'>) =>
  analyticsUtils.sendEvent('GA:promoClick', {
    elementType: 'banner',
    elementBlock, // блок, в котором расположен элемент
    promotions, // массив объектов с данными
  });
